import { typographyDesktop } from '@shared/tokens/typography.desktop.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  base: (isActive) => ({
    cursor: { default: 'pointer', ':disabled': 'not-allowed' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px',
    gap: '8px',
    backgroundColor: colors.primaryBackground,
    border: 'none',
    borderBottom: isActive ? `2px solid ${colors.accentBorder}` : `1px solid ${colors.secondaryBorder}`,
    fontStyle: 'normal',
    fontWeight: 400,
    outline: 'none',
  }),
  title: (isActive) => ({
    fontFamily: fonts.din2014Regular,
    color: isActive ? colors.primaryText : colors.secondaryText,
  }),
  medium: {
    fontSize: typographyDesktop['fontSizeCaption-1'],
    lineHeight: typographyDesktop['lineHeightCaption-1'],
  },
  large: {
    fontSize: typographyDesktop['fontSizeBody-4'],
    lineHeight: typographyDesktop['lineHeightBody-4'],
  },
  messageCount: {
    boxSizing: 'border-box',
    backgroundColor: palette['bronze-50'],
    display: 'flex',
    minWidth: anatomy['size-20'],
    height: anatomy['size-20'],
    padding: '2px 4px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: anatomy.borderRadiusRound,
    color: colors.accentText,
    fontFamily: fonts.din2014Regular,
    fontSize: typographyDesktop['fontSizeCaption-2'],
    lineHeight: typographyDesktop['lineHeightCaption-2'],
  },
});
